import type { ReactNode } from "react";

interface Props {
  open: boolean;
  title?: string;
  onClose?: () => void;
  children: ReactNode;
  /** Don't dismiss when tapping backdrop. */
  staticBackdrop?: boolean;
}

export function Modal({ open, title, onClose, children, staticBackdrop }: Props) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/60 sm:items-center"
      onClick={() => !staticBackdrop && onClose?.()}
      role="dialog"
      aria-modal
    >
      <div
        className="pp-card-shell w-full max-w-md animate-phase-pop bg-[#15162a] p-6"
        onClick={(e) => e.stopPropagation()}
      >
        {title && <h2 className="font-display text-2xl font-bold mb-3">{title}</h2>}
        {children}
      </div>
    </div>
  );
}
